const BeesoftZendesk = {

   init: function (data)
   {
      this.DJANGO_TOKEN = data.token;
      this.MESSAGES = data.messages;
      this.API_BASE_URL = data.api_url;

      this.PAGE = document.querySelector('#beesoft-zendesk-form-page');
      this.FORM = document.querySelector('form#beesoft-zendesk-form');
      this.SUCCESSBOX = document.querySelector('#beesoft-zendesk-form-success');
      this.SUBMIT_BUTTON = this.FORM.querySelector('button#zendesk-form-submit');
      this.FORM_ALERT = this.FORM.querySelector('#form-error-alert');
      this.BACK_TO_FORM_BUTTON = document.querySelector('button#back-to-form-btn');
      this.GET_PRODUCT_CODE_BUTTON = document.querySelector('button#get-product-code-btn');
      this.MODAL_TRIGGER = document.querySelectorAll('[data-toggle="modal"]');
      this.MODAL_CLOSE = document.querySelectorAll('[data-dismiss="modal"]');
      this.MODALS = document.querySelectorAll('.modal');
      this.COMPONENTI_MODAL = document.querySelector('#components-modal');

      this.USER_ID_FIELD = this.FORM.querySelector('#assign_user_id');
      this.GROUP_ID_FIELD = this.FORM.querySelector('#assign_group_id');
      this.BATCH_CODE = this.FORM.querySelector('#batch-code');
      this.PRODUCT_NAME_FIELD = this.FORM.querySelector('#nome_prodotto');
      this.COMPONENTI = this.FORM.querySelector('#search_components');
      this.COMPONENTI_FIELD = this.FORM.querySelector('#componenti');
      this.COMPONENTI_BUTTON = this.FORM.querySelector('#get-component-codes-btn');
      this.CODICE_TIPOLOGIA_FIELD = this.FORM.querySelector('#codice_tipologia');
      this.BATCH_CODE_FIELD = this.FORM.querySelector('#codice_lotto');
      this.PRODUCT_CODE_FIELD = this.FORM.querySelector('#codice_prodotto');
      this.REQUEST_DESCRIPTION_FIELD = this.FORM.querySelector('#messaggio');
      this.IMAGE_FIELD = this.FORM.querySelector('#immagine');
      this.FIRSTNAME_FIELD = this.FORM.querySelector('#nome');
      this.LASTNAME_FIELD = this.FORM.querySelector('#cognome');
      this.EMAIL_FIELD = this.FORM.querySelector('#email');
      this.TEL_FIELD = this.FORM.querySelector('#telefono');
      this.ADDRESS_FIELD = this.FORM.querySelector('#indirizzo');
      this.ZIP_FIELD = this.FORM.querySelector('#cap');
      this.CITY_FIELD = this.FORM.querySelector('#citta');
      this.PROVINCE_FIELD = this.FORM.querySelector('#provincia');
      this.COUNTRY_FIELD = this.FORM.querySelector('#codice_clemitalia');
      this.SHORT_COUNTRY_CODE = this.FORM.querySelector('#codice_clemitalia_short');
      this.PARENT_BIRTH_DATE = this.FORM.querySelector('#data_nascita_genitore');
      this.SON_BIRTH_DATE = this.FORM.querySelector('#data_nascita_figlio');
      this.POLICY_FIELD_1 = this.FORM.querySelector('#privacy_policy_1');
      this.POLICY_FIELD_2 = this.FORM.querySelector('#opt_in');


      this.PUZZLE_USERNAME = 'WgFpCB65s33kT46gJbuw';
      this.PUZZLE_PASSWORD = 'xb9HCmR3ZXwFR@!#K?N6';
      this.PUZZLE_TYPE = 'password';
      this.PUZZLE_URL_CODE = 'https://clemcloudordlav.azurewebsites.net/api/Servizi/GetOrdine';
      this.VALIDATED_PRODUCT_CODE = false;

      this.SELECTED_COMPONENTS = new Choices(this.COMPONENTI_FIELD, {
         removeItems: true,
         removeItemButton: true,
         duplicateItemsAllowed: false,
         editItems: false,
         shouldSort: false,
         searchChoices: false,
         callbackOnItemSelect: function ()
         {
            return false; // Disabilita la selezione degli elementi
         }
      });

      this.preloadAssets();
      this.setListeners();
   },

   preloadAssets: function ()
   {
      const l = document.createElement('link');
      l.rel = 'preload';
      l.as = 'image';
      l.href = 'https://cdnjs.cloudflare.com/ajax/libs/galleriffic/2.0.1/css/loader.gif';
      const head = document.getElementsByTagName("head")[0];
      head.insertBefore(l, head.firstChild);
   },

   checkValid: function (obj)
   {
      return Object.values(obj).every(function (value)
      {
         return value === true;
      })
   },

   setListeners: function ()
   {
      const _self = this;

      //al change del campo #codice_tipologia verifico se è necessario mostrare il campo #codice_lotto
      this.CODICE_TIPOLOGIA_FIELD.addEventListener('change', function ()
      {
         _self.handleRequestTypeChange(this.value);
      }, false);

      this.GET_PRODUCT_CODE_BUTTON.addEventListener('click', function ()
      {

         if (_self.BATCH_CODE_FIELD.value)
         {
            _self.checkBatchCode(_self.BATCH_CODE_FIELD);
         } else
         {
            _self.clearError('codice_lotto');
         }

      }, false);

      this.BATCH_CODE_FIELD.addEventListener('input', function ()
      {
         this.BATCH_CODE_FIELD.value = this.BATCH_CODE_FIELD.value.replace(/[^a-zA-Z0-9]/g, '');
         if (this.PRODUCT_CODE_FIELD.value !== '')
         {
            this.PRODUCT_CODE_FIELD.value = '';
         }
      }.bind(this));

      this.COUNTRY_FIELD.addEventListener('change', function (event)
      {
         const selectedOption = this.options[this.selectedIndex];
         const provinceLabelReq = _self.FORM.querySelector(`label[for="${_self.PROVINCE_FIELD.id}"] span.req`);
         if (typeof selectedOption.dataset?.provRequired !== 'undefined')
         {
            _self.PROVINCE_FIELD.setAttribute('required', true);
            provinceLabelReq.style.display = 'inline-block';
         } else
         {
            _self.PROVINCE_FIELD.removeAttribute('required');
            provinceLabelReq.style.display = 'none';
         }

         if (typeof selectedOption.dataset?.shortvalue !== 'undefined')
         {
            _self.SHORT_COUNTRY_CODE.value = selectedOption.dataset?.shortvalue;
         } else
         {
            _self.SHORT_COUNTRY_CODE.value = '';
         }
      }, false);

      this.FORM.addEventListener('submit', function (event)
      {
         event.preventDefault();
         _self.validate();
      }, false);

      this.COMPONENTI_BUTTON.addEventListener('click', function (event)
      {
         _self.findComponentCodes();
      });

      this.BACK_TO_FORM_BUTTON.addEventListener('click', function (event)
      {
         _self.SUCCESSBOX.querySelector('.response-text-html').innerHTML = '';
         _self.SUCCESSBOX.querySelector('.ticket-code-text').innerHTML = '';
         _self.SUCCESSBOX.classList.add('visually-hidden');
         _self.PAGE.classList.remove('visually-hidden');
         window.location.hash = '';
      }, false);

      [...this.MODAL_TRIGGER].map(function (el)
      {
         el.addEventListener('click', function ()
         {
            const targ = el.dataset.target;
            document.querySelector(targ).classList.add('show');
         }, false)
      });

      [...this.MODAL_CLOSE].map(function (el)
      {
         el.addEventListener('click', function ()
         {
            [..._self.MODALS].map(function (m)
            {
               m.classList.remove('show');
            });
         }, false)
      });

      document.body.addEventListener('submit', function (event)
      {
         const target = event.target;
         if (target.matches('#zendesk-components-form'))
         {
            event.preventDefault();
            const formData = new FormData(target);
            const formDataObject = Object.fromEntries(formData);
            console.log('formDataObject', formDataObject);

            const dataArray = Object.keys(formDataObject).reduce((acc, key) =>
            {
               const match = key.match(/items\[(.*?)\]\[(.*?)\]/);
               if (match)
               {
                  const itemKey = match[1];
                  const property = match[2];
                  const item = acc.find((i) => i.value === itemKey);
                  if (item)
                  {
                     if (property === 'quantity')
                     {
                        item.customProperties.quantity = parseInt(formDataObject[key], 10);
                     }
                  } else
                  {
                     const newItem = {
                        label: `${formDataObject[`items[${itemKey}][quantity]`]} x ${itemKey}`,
                        value: itemKey,
                        customProperties: {
                           quantity: parseInt(formDataObject[`items[${itemKey}][quantity]`], 10),
                        }
                     };
                     acc.push(newItem);
                  }
               }
               return acc;
            }, []);

            //const values = Object.values(formDataObject);
            console.log(dataArray);

            _self.SELECTED_COMPONENTS.clearStore().setValue(dataArray);
            _self.COMPONENTI_MODAL.close();
         }
      });

      document.body.addEventListener('change', function (event)
      {
         const target = event.target;
         const selector = 'input.component-item--code';
         const el = target.matches(selector) ? target : target.closest(selector) ? target.closest(selector) : null;
         if (el)
         {
            const label = el.nextElementSibling;
            const relQuantity = label.querySelector('input.component-item--quantity');
            if (relQuantity)
            {
               relQuantity.disabled = !el.checked;
               relQuantity.focus();
            }
         }
      });
   },

   renderComponentiList: function (data)
   {

      const _self = this;

      const modalTitle = _self.COMPONENTI_MODAL.querySelector('.dialog-title');
      const modalBody = _self.COMPONENTI_MODAL.querySelector('form#zendesk-components-form');
      const currentValues = _self.SELECTED_COMPONENTS.getValue(true);

      _self.PRODUCT_NAME_FIELD.value = data?.nome;

      const template = `
         <div class="componentilist--header">
            <div class="componentilist--product-image">
               <img src="${this.API_BASE_URL + data?.immagine}" loading="lazy" class="img-fluid" />
            </div>
         </div>
         <ul class="componentilist--content">
            ${data.items.map((item, index) =>
      {
         return `
                  <li>
                     <input${currentValues && currentValues.includes(item.codice) ? ' checked' : ''} hidden type="checkbox" class="component-item--code" id="item-${item.codice}-value" name="items[${item.codice}][value]" value="${item.codice}" />
                     <label for="item-${item.codice}-value">
                        <div class="componentilist--item-checkbox">
                           <span></span>
                        </div>
                        <div class="componentilist--item-code">
                           ${item.codice}
                        </div>
                        <div class="componentilist--item-image">
                           <span><img src="${this.API_BASE_URL + item?.immagine}" loading="lazy" class="img-fluid" /></span>
                        </div>
                        <div class="componentilist--item-parts">
                        ${item.contenuto}
                        </div>
                        <div class="componentilist--item-quantity">
                           <input type="number" name="items[${item.codice}][quantity]" class="component-item--quantity" value="1" min="1" disabled />
                        </div>
                     </label>
                  </li>
               `
      }).join('')}
         </ul>
      `;

      modalTitle.textContent = data?.nome;
      modalBody.innerHTML = template;
      _self.COMPONENTI_MODAL.showModal();

   },

   findComponentCodes: async function ()
   {
      const _self = this;

      _self.clearError('componenti');
      _self.clearError('codice_prodotto');

      const product_code = _self.PRODUCT_CODE_FIELD.value;

      if (!product_code)
      {
         _self.PRODUCT_CODE_FIELD.focus();
         _self.setError('codice_prodotto', _self.MESSAGES.required_product_code);
         return;
      }

      _self.COMPONENTI_BUTTON.disabled = true;
      _self.COMPONENTI_BUTTON.classList.add('loading');

      _self.SELECTED_COMPONENTS.clearStore();

      const controller = new AbortController();
      const signal = controller.signal;
      //test 19223
      try
      {
         const res = await fetch(`${_self.API_BASE_URL}/assistenza/api/form/products/?codice=${product_code}`, {
            signal,
            method: 'GET',
            headers: {
               'Authorization': `Token ${_self.DJANGO_TOKEN}`
            }
         });

         if (!res.ok)
         {
            const data = await res.json();
            if (res.status === 555)
            {
               data.message = _self.MESSAGES.components_not_found;
            }
            throw new Error(data.message);
         }

         const response = await res.json();
         _self.renderComponentiList(response);
      } catch (err)
      {
         _self.setError('codice_prodotto', err.message);
         _self.COMPONENTI_BUTTON.classList.remove('loading');
         _self.COMPONENTI_BUTTON.disabled = false;
         return false;
      } finally
      {
         _self.COMPONENTI_BUTTON.classList.remove('loading');
         _self.COMPONENTI_BUTTON.disabled = false;
      }
   },

   bytesToSize: function (bytes)
   {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return 'n/a';
      const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10);
      if (i === 0) return `${bytes} ${sizes[i]}`;
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
   },

   validate: function ()
   {
      const _self = this;
      const errors = [];

      const VALID = {
         nome_prodotto: true,
         codice_tipologia: true,
         codice_lotto: true,
         codice_prodotto: true,
         componenti: true,
         messaggio: true,
         immagine: true,
         nome: true,
         cognome: true,
         email: true,
         telefono: true,
         indirizzo: true,
         cap: true,
         citta: true,
         provincia: true,
         codice_clemitalia: true,
         data_nascita_genitore: true,
         data_nascita_figlio: true,
         privacy_policy: true,
         opt_in: true
      };

      _self.clearAllErrors();

      if (!this.PRODUCT_NAME_FIELD.value)
      {
         VALID.nome_prodotto = false;
         errors.push({
            key: 'nome_prodotto',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.PRODUCT_CODE_FIELD.value)
      {
         VALID.codice_prodotto = false;
         errors.push({
            key: 'codice_prodotto',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.CODICE_TIPOLOGIA_FIELD.value)
      {
         VALID.codice_tipologia = false;
         VALID.codice_lotto = true;
         errors.push({
            key: 'codice_tipologia',
            message: _self.MESSAGES.required_field
         });
      } else
      {
         VALID.codice_tipologia = true;
         switch (_self.CODICE_TIPOLOGIA_FIELD.value)
         {
            case 'p_causali_ps': {
               if (!_self.BATCH_CODE_FIELD.value)
               {
                  VALID.codice_lotto = false;
                  errors.push({
                     key: 'codice_lotto',
                     message: _self.MESSAGES.required_field
                  });
               } else if (_self.BATCH_CODE_FIELD.value.length < 16)
               {
                  VALID.codice_lotto = false;
                  errors.push({
                     key: 'codice_lotto',
                     message: _self.MESSAGES.invalid_batch_code
                  });
               }
               break;
            }
            // case 'p_causali_cm':
            // case 'p_causali_cd': {
            //    if (!_self.COMPONENTI_FIELD.value)
            //    {
            //       VALID.componenti = false;
            //       errors.push({
            //          key: 'componenti',
            //          message: _self.MESSAGES.required_field
            //       });
            //    }
            // }
         }
      }

      if (!this.REQUEST_DESCRIPTION_FIELD.value)
      {
         VALID.messaggio = false;
         errors.push({
            key: 'messaggio',
            message: _self.MESSAGES.required_field
         });
      }

      if (this.IMAGE_FIELD.value)
      {
         const field = this.IMAGE_FIELD;
         const files = field.files;
         if (files.length)
         {
            const file = files[0];
            const allowedExtensions = field.dataset.formExtensions.split(',');
            const fileSizeLimit = field.dataset.formSize;
            const extension = file.name.split(".").pop();
            if (!allowedExtensions.includes(extension))
            {
               VALID.immagine = false;
               errors.push({
                  key: 'immagine',
                  message: _self.MESSAGES.file_type
               });
            } else if (file.size > fileSizeLimit)
            {
               VALID.immagine = false;
               errors.push({
                  key: 'immagine',
                  message: _self.MESSAGES.file_size
               });
            }
         }
      }

      if (!this.FIRSTNAME_FIELD.value)
      {
         VALID.nome = false;
         errors.push({
            key: 'nome',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.LASTNAME_FIELD.value)
      {
         VALID.cognome = false;
         errors.push({
            key: 'cognome',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.EMAIL_FIELD.value)
      {
         VALID.email = false;
         errors.push({
            key: 'email',
            message: _self.MESSAGES.required_field
         });
      } else
      {
         const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
         if (!validRegex.test(_self.EMAIL_FIELD.value))
         {
            VALID.email = false;
            errors.push({
               key: 'email',
               message: _self.MESSAGES.invalid_email
            });
         }
      }

      if (!this.TEL_FIELD.value)
      {
         VALID.telefono = false;
         errors.push({
            key: 'telefono',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.ADDRESS_FIELD.value)
      {
         VALID.indirizzo = false;
         errors.push({
            key: 'indirizzo',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.ZIP_FIELD.value)
      {
         VALID.cap = false;
         errors.push({
            key: 'cap',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.CITY_FIELD.value)
      {
         VALID.citta = false;
         errors.push({
            key: 'citta',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.PROVINCE_FIELD.value)
      {
         if (this.PROVINCE_FIELD.required)
         {
            VALID.provincia = false;
            errors.push({
               key: 'provincia',
               message: _self.MESSAGES.required_field
            });
         }
      }

      if (!this.COUNTRY_FIELD.value)
      {
         VALID.codice_clemitalia = false;
         errors.push({
            key: 'codice_clemitalia',
            message: _self.MESSAGES.required_field
         });
      }

      if (!this.POLICY_FIELD_1.checked)
      {
         VALID.privacy_policy = false;
         errors.push({
            key: 'privacy_policy_1',
            message: _self.MESSAGES.required_field
         });
      }

      // if (!this.POLICY_FIELD_2.checked)
      // {
      //    VALID.opt_in = false;
      //    errors.push({
      //       key: 'opt_in',
      //       message: _self.MESSAGES.required_field
      //    });
      // }

      const isValid = _self.checkValid(errors);
      console.log('isValid', isValid);

      if (!isValid)
      {
         _self.FORM_ALERT.innerText = _self.MESSAGES.fields_error;
         _self.FORM_ALERT.style.display = 'block';

         errors.forEach(function (error)
         {
            _self.setError(error.key, error.message);
         });

         return;
      }

      this.handleSubmit();
   },

   handleSubmit: async function ()
   {
      const _self = this;

      const defaultSubmitButtonLabel = _self.SUBMIT_BUTTON.dataset.defaultLabel;
      _self.SUBMIT_BUTTON.setAttribute('disabled', true);
      _self.SUBMIT_BUTTON.innerText = _self.MESSAGES.sending;

      const formData = new FormData();

      formData.append('image', this.IMAGE_FIELD.files[0]);
      formData.append('assign_user_id', this.USER_ID_FIELD.value);
      formData.append('assign_group_id', this.GROUP_ID_FIELD.value);
      formData.append('codice_clemitalia', this.COUNTRY_FIELD.value);
      formData.append('codice_clemitalia_short', this.SHORT_COUNTRY_CODE.value);
      formData.append('nome', this.FIRSTNAME_FIELD.value);
      formData.append('cognome', this.LASTNAME_FIELD.value);
      formData.append('indirizzo', this.ADDRESS_FIELD.value);
      formData.append('citta', this.CITY_FIELD.value);
      formData.append('cap', this.ZIP_FIELD.value);
      formData.append('provincia', this.PROVINCE_FIELD.value);
      formData.append('telefono', this.TEL_FIELD.value);
      formData.append('email', this.EMAIL_FIELD.value);
      formData.append('nome_prodotto', this.PRODUCT_NAME_FIELD.value);
      formData.append('codice_prodotto', this.PRODUCT_CODE_FIELD.value);
      formData.append('codice_lotto', this.BATCH_CODE_FIELD.value);
      formData.append('messaggio', this.REQUEST_DESCRIPTION_FIELD.value);
      formData.append('opt_in', this.POLICY_FIELD_2.checked.toString());
      formData.append('codice_tipologia', this.CODICE_TIPOLOGIA_FIELD.value);
      formData.append('data_nascita_genitore', this.PARENT_BIRTH_DATE.value);
      formData.append('data_nascita_figlio', this.SON_BIRTH_DATE.value);

      const valueArray = this.SELECTED_COMPONENTS.getValue();
      if (valueArray.length > 0)
      {
         const componentiValue = valueArray.map((choice) =>
         {
            return {
               codice: choice.value,
               qta: choice.customProperties.quantity
            }
         });
         formData.append('componenti', JSON.stringify(componentiValue));
      }

      let controller = new AbortController();
      const signal = controller.signal;

      const response = await fetch(`${_self.API_BASE_URL}/assistenza/api/form/`, {
         signal,
         method: 'POST',
         headers: {
            'Authorization': `Token ${_self.DJANGO_TOKEN}`
         },
         body: formData
      }).then((res) =>
      {
         if (!res.ok)
         {
            throw new Error(`HTTP error: ${res.status}`);
         }

         return res.json();
      }).then((jsondata) =>
      {
         console.log('jsondata', jsondata);
         return jsondata;
      }).catch(err =>
      {
         console.log(err);
         _self.FORM_ALERT.innerText = _self.MESSAGES.server_error.replace('{{error}}', err.message);
         _self.FORM_ALERT.style.display = 'block';
         _self.SUBMIT_BUTTON.removeAttribute('disabled');
      });

      if (response?.result === 'OK')
      {
         const boxTitle = _self.SUCCESSBOX.querySelector('.response-text-html');
         const boxTicketText = _self.SUCCESSBOX.querySelector('.ticket-code-text');
         boxTitle.innerHTML = _self.MESSAGES.success.response_text_html.replace('{{fullname}}', response.data.requester_name);
         boxTicketText.innerHTML = _self.MESSAGES.success.ticket_code_text.replace('{{code}}', response.data.ticket_id);
         _self.SUCCESSBOX.classList.remove('visually-hidden');
         _self.PAGE.classList.add('visually-hidden');
         _self.FORM.reset();
         _self.BATCH_CODE.classList.remove('active');
         _self.SUBMIT_BUTTON.innerText = defaultSubmitButtonLabel;
         _self.SUBMIT_BUTTON.removeAttribute('disabled');
         window.location.hash = 'beesoft-zendesk-form-success';
      }
   },

   checkBatchCode: async function (element)
   {
      const _self = this;

      _self.SUBMIT_BUTTON.setAttribute('disabled', true);
      _self.GET_PRODUCT_CODE_BUTTON.setAttribute('disabled', true);

      element.classList.add('loading');

      //impedisco la modifica dei campi codice_prodotto e codice_lotto
      element.setAttribute('readonly', true);
      _self.PRODUCT_CODE_FIELD.value = '';

      //recupero da django il token necessario alla chiamata che recupera il codice prodotto dal codice lotto
      const res = await this.getClemToken();
      if (res?.result !== 'OK')
      {
         element.removeAttribute('readonly');
         _self.setError('codice_lotto', res.clem_error);
         _self.SUBMIT_BUTTON.removeAttribute('disabled');
         _self.GET_PRODUCT_CODE_BUTTON.removeAttribute('disabled');
         return;
      }

      const token = res?.data?.clem_token;

      //recupero il codice prodotto dal codice lotto
      const product_code = await _self.getProductCode(token, element.value);

      //nel caso in cui la risposta inizi con la stringa 'KO-', gestisco l'errore
      if (product_code.startsWith('KO-'))
      {
         let error_message = '';

         if (product_code.includes('Codice non trovato'))
         {
            error_message = _self.MESSAGES.product_code_not_found;
         } else if (product_code.includes('previsti 16 caratteri'))
         {
            error_message = _self.MESSAGES.invalid_batch_code;
         } else
         {
            error_message = product_code.slice(3);
         }

         element.classList.remove('loading');
         element.removeAttribute('readonly');
         _self.setError('codice_lotto', error_message);
         _self.SUBMIT_BUTTON.removeAttribute('disabled');
         _self.GET_PRODUCT_CODE_BUTTON.removeAttribute('disabled');
         return;
      }

      //imposto il campo codice_prodotto col valore ottenuto
      element.removeAttribute('readonly');
      _self.PRODUCT_CODE_FIELD.value = product_code;
      _self.VALIDATED_PRODUCT_CODE = true;
      _self.SUBMIT_BUTTON.removeAttribute('disabled');
      _self.GET_PRODUCT_CODE_BUTTON.removeAttribute('disabled');
      element.classList.remove('loading');
   },

   toQueryString: function (object)
   {
      return Object.keys(object).map(function (key)
      {
         return key + '=' + object[key]
      }).join('&');
   },

   getProductCode: async function (token, code)
   {
      const _self = this;

      let controller = new AbortController();
      const signal = controller.signal;

      const response = await fetch(`${_self.PUZZLE_URL_CODE}?value=${code}`, {
         signal,
         method: 'GET',
         headers: {
            'Content-Type': "application/x-www-form-urlencoded",
            'Authorization': `Bearer ${token}`
         }
      }).then((res) =>
      {
         if (!res.ok)
         {
            throw new Error(`HTTP error: ${res.status}`);
         }

         return res.json();
      }).then((jsondata) =>
      {
         return jsondata;
      }).catch(err =>
      {
         console.log(err);
         _self.setError('codice_lotto', _self.MESSAGES.server_error.replace('{{error}}', err.message));
      });

      return response;
   },

   getClemToken: async function ()
   {
      const _self = this;
      this.clearError('codice_lotto');

      let controller = new AbortController();
      const signal = controller.signal;

      const response = await fetch(`${_self.API_BASE_URL}/assistenza/api/token/`, {
         signal,
         method: 'POST',
         headers: {
            'Authorization': `Token ${_self.DJANGO_TOKEN}`
         }
      })
         .then((res) =>
         {
            if (!res.ok)
            {
               throw new Error(`HTTP error: ${res.status}`);
            }

            return res.json();
         }).then((jsondata) =>
         {
            return jsondata;
         }).catch(err =>
         {
            console.log(err);
            _self.setError('codice_lotto', err.message);
         });

      return response;
   },

   handleRequestTypeChange: function (value)
   {
      const _self = this;
      _self.clearAllErrors();

      this.SELECTED_COMPONENTS.clearStore();
      this.PRODUCT_CODE_FIELD.value = '';
      this.BATCH_CODE_FIELD.value = '';

      switch (value)
      {
         case 'p_causali_ps': {
            _self.clearError('codice_lotto');
            _self.BATCH_CODE.classList.add('active');
            _self.BATCH_CODE_FIELD.removeAttribute('disabled');
            _self.BATCH_CODE_FIELD.setAttribute('required', true);
            _self.COMPONENTI.classList.remove('active');
            _self.SELECTED_COMPONENTS.disable();
            _self.PRODUCT_CODE_FIELD.setAttribute('readonly', true);
            _self.COMPONENTI_BUTTON.classList.remove('active');
            //_self.PRODUCT_CODE_FIELD.value = '';
            break;
         }
         case 'p_causali_cm':
         case 'p_causali_cd': {
            _self.clearError('componenti');
            _self.BATCH_CODE.classList.remove('active');
            //_self.BATCH_CODE_FIELD.value = '';
            _self.BATCH_CODE_FIELD.setAttribute('disabled', true);
            _self.BATCH_CODE_FIELD.removeAttribute('required');
            _self.BATCH_CODE_FIELD.removeAttribute('readonly');
            _self.PRODUCT_CODE_FIELD.removeAttribute('readonly');
            //_self.PRODUCT_CODE_FIELD.value = '';
            _self.COMPONENTI.classList.add('active');
            _self.COMPONENTI_BUTTON.classList.add('active');
            console.log(_self.COMPONENTI_BUTTON);
            _self.SELECTED_COMPONENTS.enable();
            break;
         }
         default: {
            _self.BATCH_CODE.classList.remove('active');
            //_self.BATCH_CODE_FIELD.value = '';
            _self.BATCH_CODE_FIELD.setAttribute('disabled', true);
            _self.BATCH_CODE_FIELD.removeAttribute('readonly');
            _self.BATCH_CODE_FIELD.removeAttribute('required');
            _self.COMPONENTI.classList.remove('active');
            _self.SELECTED_COMPONENTS.disable();
            _self.PRODUCT_CODE_FIELD.removeAttribute('readonly');
            _self.COMPONENTI_BUTTON.classList.remove('active');
         }

      }
   },

   setError: function (fieldId, message)
   {
      const field = document.getElementById(fieldId);
      field.classList.add('error');

      const error = document.createElement('div');
      error.classList.add('form-field-error');
      error.setAttribute('data-field-id', fieldId);
      error.innerHTML = message;

      console.log('fieldId', fieldId);
      field.closest('.o-layout__item').append(error);

      // if (fieldId === 'componenti')
      // {
      //    field.closest('.choices').after(error);
      // } else
      // {
      //    field.after(error);
      // }
   },

   clearError: function (fieldId)
   {
      const field = document.getElementById(fieldId);
      field.classList.remove('error');
      const error = document.querySelector(`.form-field-error[data-field-id="${fieldId}"]`);
      if (error)
      {
         error.remove();
      }
   },

   clearAllErrors: function ()
   {
      const _self = this;
      if (_self.FORM)
      {
         _self.FORM_ALERT.style.display = 'none';
         _self.FORM_ALERT.innerText = '';

         const formFields = _self.FORM.querySelectorAll('input, select, textarea');
         if (formFields.length)
         {
            [...formFields].map(function (el)
            {
               el.classList.remove('error');
               const id = el.id;
               const error = _self.FORM.querySelector(`.form-field-error`);
               if (error)
               {
                  error.remove();
               }
            });
         }
      }
   }

}

window.addEventListener('zendesk:init', function (event)
{
   BeesoftZendesk.init(event.detail);
}, false);
